import { Status } from './gallery';

export default class PlaybackButton {
    constructor(gallery) {
        this.gallery = gallery;
        this.playbackButton = gallery.dom.playbackButton;
        this.playbackButton.addEventListener('click', () => this.handleClick());
        this.gallery.addEventListener('indexchange', () => this.render());
        this.gallery.addEventListener('statuschange', () => this.render());
        this.applyVocabs();
    }

    render() {
        const { index, status } = this.gallery.state;

        const atEnd = index === this.gallery.length() - 1;
        let buttonStatus = 'pause';
        if (atEnd && status === Status.Idle) {
            buttonStatus = 'replay';
        }
        else if (status === Status.Idle) {
            buttonStatus = 'play';
        }
        this.playbackButton.className = `icon-button icon-button--${buttonStatus}`;
        this.playbackButton.setAttribute('aria-pressed', buttonStatus === 'pause');
        this.playbackButton.setAttribute('title', __(buttonStatus));
    }

    /**
     * Apply vocabs text for buttons, etc.
     * @private
     */
    applyVocabs() {
        this.playbackButton.setAttribute('aria-label', __('play'));
        this.playbackButton.setAttribute('aria-pressed', false);
    }

    handleClick() {
        const { index, status } = this.gallery.state;
        const atEnd = index === this.gallery.length() - 1;
        if (atEnd && status === Status.Idle) {
            this.gallery.setIndex(0);
            this.gallery.play();
            return;
        }
        if (status === Status.Idle) {
            this.gallery.play();
            return;
        }
        this.gallery.pause();
    }
}
